import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

/**
 * Guardia che si occupa di assicurarsi che nell'url delle
 * rotte del flusso di ticketing sia presente il codice esetero,
 * se non e' presente (es. di ritorno dal login) cerca nel local
 * storage una entry *`selected-museum`*, se la trova la posiziona
 * nell'url, se non la trova forza la navigazione verso il Pantheon.
 *
 * In ogni caso mantiene gli eventuali query params aggiuntivi
 * tipo *`esito`* quando l'utente ritorna nel portale post
 * pagamento.
 *
 * @param route
 * @param state
 * @returns
 */
export const ensureCodesrGuard: CanActivateFn = (route, _state) => {

  const router = inject(Router);

  const codesr = route.params['codesr'];
  if(codesr) return true;

  let fallbackCodesr: string | null = null;

  fallbackCodesr = localStorage.getItem('selected-museum');

  if (!fallbackCodesr) {
    // Hardcoding del Pantheon come ultima risorsa
    fallbackCodesr = '33f77159-0acd-40c4-8524-701f33aae108';
  }

  // Reindirizzo alla rotta completa, preservando eventuali query params (es. esito)
  return router.createUrlTree(
    ['/buyTicketless', fallbackCodesr],
    { queryParams: route.queryParams }
  );
};
